(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["emarsys-newsletter"] && !window.DesignMode) return;
  try {
    
  class EmarsysNewsletterForm extends HTMLElement {
    form = null;
    error = null;
    form_language = 'en';
    messagesBox = null;
    firstNameInput = null;
    emailInput = null;
    mobileInput = null;
    submitButton = null;
    shopifyForm = null;
    optin = null;

    constructor() {
      super();
      this.shopifyForm = this.querySelector('[data-shopify-form]');
      this.messagesBox = this.querySelector('[data-emarsys-newsletter-messages]');
      this.firstNameInput = this.querySelector('[data-emarsys-first-name]');
      this.emailInput = this.querySelector('[data-emarsys-email]');
      this.mobileInput = this.querySelector('[data-emarsys-mobile]');
      this.submitButton = this.querySelector('[data-emarsys-button]');

      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const shopify_success = urlParams.get('customer_posted');

      this.initEvents();

      if (shopify_success == 'true') {
        this.scrollToForm();
      }
    }

    scrollToForm = () => {
      const formElem = document.querySelector('[data-emarsys-form]');
      setTimeout(() => {
        this.shopifyForm.scrollIntoView({
          behavior: 'auto',
          block: 'center',
        });
      }, 200);

      this.messagesBox.innerHTML = this.messagesBox.dataset.successMsg;
      this.shopifyForm.classList.add('success');
    };

    onBeforeSubmit = () => {
      return true;
    };

    is_0_valid() {
      let count = 0;

      if (this.optin) {
        if (this.optin.checked) {
          if (this.getElementsByName('interest[]')) {
            if (this.getElementsByName('interest[]').length > 0) {
              Interest = this.getElementsByName('interest[]');
              for (i = 0; i < Interest.length; i++) {
                if (Interest[i].checked) {
                  ++count;
                }
              }
              if (count == 0) {
                this.error += 'Interests:';
                return false;
              }
            }
          }
        }
      }
      return true;
    }

    displayError(error) {
      if (this.messagesBox) {
        this.messagesBox.innerHTML = error;
        this.messagesBox.classList.add('error');
      }
    }

    clearMessagebox() {
      if (this.messagesBox) {
        this.messagesBox.innerHTML = '';
        this.messagesBox.classList.remove('error');
      }
    }

    isValidEmail(email) {
      const regex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return regex.test(email);
    }

    CheckInputs() {
      let check_ok = true;
      this.error = 'Please check the fields marked in red!\n';

      check_ok = this.is_0_valid() && check_ok;
      if (this.firstNameInput && this.firstNameInput.value == '') {
        this.firstNameInput.classList.add('error');
        check_ok = false;
      } else {
        this.firstNameInput.classList.remove('error');
      }
      if (this.emailInput && (this.emailInput.value == '' || !this.isValidEmail(this.emailInput.value))) {
        this.emailInput.classList.add('error');
        check_ok = false;
      } else {
        this.emailInput.classList.remove('error');
      }
      if (this.mobileInput && this.mobileInput.value == '') {
        this.mobileInput.classList.add('error');
        check_ok = false;
      } else if (this.mobileInput) {
        this.mobileInput.value = this.mobileInput.value.replace(/\./g, '').replace(/\ /g, '');
        this.mobileInput.classList.remove('error');
      }

      if (check_ok == false) {
        this.displayError(this.error);
      }

      return check_ok;
    }

    initEvents() {
      if (this.submitButton) {
        this.submitButton.addEventListener(
          'click',
          function (e) {
            e.preventDefault();
            this.clearMessagebox();
            if (this.CheckInputs() == true) {
              this.shopifyForm.submit();
            }
          }.bind(this)
        );
      }

      if (this.mobileInput) {
        this.mobileInput.addEventListener('keydown', function (e) {
          if (e.target.value == '') {
            e.target.value = '+';
          }
          if (
            e.keyCode == 8 ||
            e.keyCode == 462 ||
            e.keyCode == 37 ||
            e.keyCode == 39 ||
            (e.keyCode >= 96 && e.keyCode <= 106)
          ) {
            return true;
          } else if (e.keyCode < 48 || e.keyCode > 57) {
            e.preventDefault();
          }
        });
      }
    }
  }

  customElements.define('emarsys-newsletter-form', EmarsysNewsletterForm);

  } catch(e) { console.error(e); }
})();
})();
